<template>
  <div class="keysWrap">
    <el-form :inline="true" size="mini" :model="form" class="search-form">
      <el-form-item :label="$tt('用途')">
        <el-input
          v-model="form.use_scenes"
          :placeholder="$tt('用途关键字')"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$tt('激活状态')">
        <el-select v-model="form.status" clearable :placeholder="$tt('全部')" style="width: 120px">
          <el-option :label="$tt('未激活')" :value="0" />
          <el-option :label="$tt('已激活')" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$tt('设备SN')">
        <el-input v-model="form.sn" :placeholder="$tt('设备SN关键字')"></el-input>
      </el-form-item>
      <el-form-item :label="$tt('激活用户(手机号)')">
        <el-input
          v-model="form.phone"
          :placeholder="$tt('用户手机号关键字')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$tt('屏蔽数据(用途中存在测试字样)')">
        <el-radio v-model="form.test" label="1">{{ $tt("是") }}</el-radio>
        <el-radio v-model="form.test" label="2">{{ $tt("否") }}</el-radio>
      </el-form-item>
      <el-form-item :label="$tt('时间维度')">
        <el-select v-model="form.time_type" style="width: 140px">
          <el-option :label="$tt('创建时间')" value="create_time" />
          <el-option :label="$tt('密钥激活时间')" value="activation_time" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$tt('时间范围')">
        <el-date-picker
          v-model="form.time_range"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          :range-separator="$tt('至')"
          :start-placeholder="$tt('开始时间')"
          :end-placeholder="$tt('结束时间')"
          :default-time="['00:00:00', '23:59:59']"
          clearable
          style="width: 360px"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">{{ $tt("查询") }}</el-button>
      </el-form-item>
    </el-form>
    <div class="toolbar-row">
      <el-button
        type="primary"
        icon="el-icon-plus"
        class="addManager"
        @click="switchDialogVisible(true, 'generateKey')"
      >
        {{ $tt("生成密钥") }}
      </el-button>
      <el-radio-group v-model="viewMode" size="mini" class="view-mode-toggle">
        <el-radio-button label="table">{{ $tt("表格") }}</el-radio-button>
        <el-radio-button label="timeline">{{ $tt("时间轴") }}</el-radio-button>
      </el-radio-group>
    </div>
    <el-table
      v-show="viewMode === 'table'"
      :data="tableDataInfo.result"
      style="width: 100%"
      class="keysTable"
      border
      :default-sort="{ prop: 'create_time', order: 'descending' }"
      @sort-change="handleSortChange"
    >
      <el-table-column
        v-for="c in tableColumns"
        :key="c.prop"
        :label="$tt(c.label)"
        :width="$listColWidth(c)"
        :min-width="$listColMinWidth(c)"
        :prop="$listColProp(c)"
        :sortable="$listSortable(c) ? 'custom' : false"
        :class-name="$listColClass(c)"
        :label-class-name="$listColClass(c)"
        :fixed="$listColFixed(c)"
        :show-overflow-tooltip="$listOverflow(c)"
      >
        <template slot-scope="scope">
          <div v-if="c.prop.indexOf('time') > -1">
            {{ dateTransform(scope.row[c.prop]) }}
          </div>

          <div v-else-if="c.prop == 'level'">
            {{ $tt(getLevelName(scope.row.level)) }}
          </div>

          <div
            :class="[statusConfig[scope.row.status].class]"
            v-else-if="c.prop == 'status'"
          >
            {{ $tt(statusConfig[scope.row.status].text) }}
          </div>
          <div class="table-ops" v-else-if="c.prop == 'operations'">
            <el-popconfirm
              :title="$tt('确定要重置吗？')"
              @confirm="resetClick(scope.row.id)"
            >
              <el-button
                slot="reference"
                :disabled="scope.row.status === 0"
                size="mini"
                type="text"
                icon="el-icon-refresh"
                >{{ $tt("重置") }}</el-button
              >
            </el-popconfirm>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-link"
              @click="bindSecretKey(scope.row.id)"
            >
              {{ $tt("绑定") }}
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-time"
              :disabled="scope.row.status !== 0"
              @click="editSecretTime(scope.row.id)"
            >
              {{ $tt("修改密钥时长") }}
            </el-button>
            <el-popconfirm
              v-if="canDeleteSecret"
              :title="$tt('确定删除该密钥吗？删除后对外激活将失效。')"
              @confirm="deleteSecretKey(scope.row.id)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="text"
                class="delete-text-btn"
                icon="el-icon-delete"
              >
                {{ $tt("删除") }}
              </el-button>
            </el-popconfirm>
          </div>

          <span v-else>{{ scope.row[c.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div v-show="viewMode === 'timeline'" class="keys-timeline-wrap" v-loading="timelineLoading">
      <el-empty v-if="!timelineRows.length" :description="$tt('暂无数据')" />
      <el-timeline v-else>
        <el-timeline-item
          v-for="row in timelineRows"
          :key="row.id"
          :timestamp="timelineStamp(row)"
          placement="top"
          :type="row.status === 1 ? 'success' : 'info'"
        >
          <el-card shadow="hover" class="timeline-card">
            <div class="timeline-card-head">
              <span class="timeline-key">{{ row.secret_key }}</span>
              <span :class="statusConfig[row.status].class">{{ $tt(statusConfig[row.status].text) }}</span>
            </div>
            <div class="timeline-meta">
              <span>{{ $tt('用途') }}：{{ row.use_scenes || '—' }}</span>
              <span>{{ $tt('设备SN') }}：{{ row.sn || '—' }}</span>
              <span>{{ $tt('密钥级别') }}：{{ $tt(getLevelName(row.level)) }}</span>
            </div>
            <div class="timeline-meta">
              <span>{{ $tt('创建时间') }}：{{ dateTransform(row.create_time) || '—' }}</span>
              <span>{{ $tt('密钥激活时间') }}：{{ dateTransform(row.activation_time) || '—' }}</span>
              <span>{{ $tt('密钥时长') }}：{{ row.keys_long || '—' }}</span>
            </div>
            <div class="timeline-meta">
              <span>{{ $tt('激活用户') }}：{{ row.bind_user_name || '—' }}</span>
              <span>{{ $tt('用户电话') }}：{{ row.bind_phone || '—' }}</span>
              <span>{{ $tt('创建人') }}：{{ row.create_by || '—' }}</span>
            </div>
            <div class="table-ops timeline-ops">
              <el-popconfirm
                :title="$tt('确定要重置吗？')"
                @confirm="resetClick(row.id)"
              >
                <el-button
                  slot="reference"
                  :disabled="row.status === 0"
                  size="mini"
                  type="text"
                  icon="el-icon-refresh"
                >{{ $tt("重置") }}</el-button>
              </el-popconfirm>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-link"
                @click="bindSecretKey(row.id)"
              >{{ $tt("绑定") }}</el-button>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-time"
                :disabled="row.status !== 0"
                @click="editSecretTime(row.id)"
              >{{ $tt("修改密钥时长") }}</el-button>
              <el-popconfirm
                v-if="canDeleteSecret"
                :title="$tt('确定删除该密钥吗？删除后对外激活将失效。')"
                @confirm="deleteSecretKey(row.id)"
              >
                <el-button
                  slot="reference"
                  size="mini"
                  type="text"
                  class="delete-text-btn"
                  icon="el-icon-delete"
                >{{ $tt("删除") }}</el-button>
              </el-popconfirm>
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
    <Pagination
      v-if="tableDataInfo.total > 8"
      :handleSizeChange="handleSizeChange"
      :handleCurrentPageChange="handleCurrentPageChange"
      :total="tableDataInfo.total"
    />
    <CommonDialog
      v-if="dialogVisible"
      :visible="dialogVisible"
      :switchDialogVisible="switchDialogVisible"
      :activeDialogKey="activeDialogKey"
      :refresh="refresh"
      :secretKeyId="activeSecretKeyId"
    />
    <el-dialog width="300px" :title="$tt('修改密钥时长')" :visible.sync="editVisible">
      <el-date-picker
        v-model="editTime"
        type="datetime"
        :placeholder="$tt('选择日期时间')"
        value-format="yyyy-MM-dd HH:mm:ss"
        :pickerOptions="pickerOptions"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editHide">{{ $tt("取 消") }}</el-button>
        <el-button type="primary" @click="editConfirm">{{ $tt("确 定") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import Pagination from '@/components/Pagination'
import CommonDialog from './commonDialog.vue'
import { mapState } from 'vuex'
import { getTimeStr } from '@/utils/utils'
import { isSuperAdmin } from '@/utils/account'
export default {
  data() {
    return {
      editVisible: false,
      editTimeId: '',
      editTime: '',
      viewMode: 'table',
      timelineLoading: false,
      form: {
        test: '1',
        use_scenes: '',
        status: '',
        sn: '',
        phone: '',
        time_type: 'create_time',
        time_range: null,
      },
      sortColumn: 'create_time',
      sortOrder: 'descending',
      statusConfig: {
        0: {
          text: '未激活',
          class: 'inactive',
        },
        1: {
          text: '已激活',
          class: 'active',
        },
      },
      tableColumns: [
        {
          label: '密钥',
          prop: 'secret_key',
          width: 120,
        },
        {
          label: '用途',
          prop: 'use_scenes',
          width: 120,
        },
        {
          label: '创建人',
          prop: 'create_by',
        },
        {
          label: '密钥时长',
          prop: 'keys_long',
          width: 140,
        },
        {
          label: '创建时间',
          prop: 'create_time',
          width: 140,
        },
        {
          label: '密钥激活时间',
          prop: 'activation_time',
          width: 140,
        },
        {
          label: '状态',
          prop: 'status',
          width: 80,
        },
        {
          label: '设备SN',
          prop: 'sn',
        },
        {
          label: '密钥级别',
          prop: 'level',
          width: 120,
        },
        {
          label: '激活用户',
          prop: 'bind_user_name',
          width: 140,
        },
        {
          label: '用户电话',
          prop: 'bind_phone',
          width: 100,
        },
        {
          label: '操作',
          prop: 'operations',
          width: '380',
          fixed: 'right',
        },
      ],
      tableDataInfo: {},
      resetPwdForm: {},
      searchValue: '',
      activeManagerId: '',
      activeSecretKeyId: '',
      activeDialogKey: '',
      dialogVisible: false,
      pageInfo: {
        page_num: 1,
        page_size: 8,
      },
    }
  },
  computed: {
    ...mapState(['projectLevels', 'loginAccountInfo']),
    canDeleteSecret() {
      const info = this.loginAccountInfo || {}
      return !!(info.is_manage || info.isManage || isSuperAdmin(info))
    },
    timelineRows() {
      const field = this.form.time_type === 'activation_time' ? 'activation_time' : 'create_time'
      let rows = (this.tableDataInfo && this.tableDataInfo.result) || []
      const range = this.form.time_range
      if (range && range.length === 2) {
        const start = new Date(range[0]).getTime()
        const end = new Date(range[1]).getTime()
        if (!Number.isNaN(start) && !Number.isNaN(end)) {
          rows = rows.filter((row) => {
            const raw = row[field]
            if (!raw) return false
            const t = new Date(raw).getTime()
            return !Number.isNaN(t) && t >= start && t <= end
          })
        }
      }
      return rows.slice().sort((a, b) => {
        const ta = a[field] ? new Date(a[field]).getTime() : 0
        const tb = b[field] ? new Date(b[field]).getTime() : 0
        return tb - ta
      })
    },
    pickerOptions() {
      // 选择的日期
      let curDate = this.editTime ? getTimeStr(this.editTime) : ''
      // 最小日期
      let minTime = new Date()
      // 最大日期
      let minDate = getTimeStr(minTime)
      // 前推一天，防止当天日期无法选择
      let preTime = minTime
      if (getTimeStr(minTime, 'HH:mm:ss') !== '00:00:00') {
        preTime = minTime - 24 * 3600000
      }
      // 如果选择的日期为最小日期，则设置为最小日期的时分秒
      let str = ''
      if (curDate === minDate) {
        str = getTimeStr(minTime, 'HH:mm:ss')
      } else {
        str = '00:00:00'
      }
      let maxStr = '23:59:59'
      // if (curDate === maxDate) {
      //     maxStr = getTimeStr(maxTime, 'HH:mm:ss');
      // } else {
      //     maxStr = '23:59:59';
      // }
      return {
        disabledDate: (date) => {
          // return date.getTime() < new Date(this.initTime).getTime()
          // || date.getTime() > new Date().getTime();
          return date.getTime() < preTime
        },
        selectableRange: str + ' - ' + maxStr,
      }
    },
  },
  components: {
    Pagination,
    CommonDialog,
  },
  mounted() {
    this.$store.dispatch('getProjectLevelsAction', {})
    this.getTableData({})
  },
  watch: {
    viewMode(mode) {
      if (mode === 'timeline') {
        this.getTableData({ page_num: 1 })
      }
    },
  },
  methods: {
    editHide() {
      this.editTimeId = ''
      this.editTime = ''
      this.editVisible = false
    },
    editConfirm() {
      if (!this.editTime) {
        this.$message.error('时间不能为空')
        return
      }
      // 如果选定时间小于当前时间需要提示，不能保存
      let editTimeNum = new Date(this.editTime).getTime()
      let nowNum = new Date().getTime()
      if (editTimeNum <= nowNum) {
        this.$message.error('不能小于当前时间')
        return
      }
      // 更改
      this.$request
        .updateEndingTime({
          id: this.editTimeId,
          end_time: new Date(this.editTime).getTime(),
        })
        .then((res) => {
          if (res.status != 'success') {
            this.$message.error(res.msg)
            return
          }
          this.editHide()
          this.getTableData({})
        })
    },
    onSearch() {
      this.getTableData({ page_num: 1 })
    },
    handleSortChange({ prop, order }) {
      if (!prop || !order) {
        this.sortColumn = 'create_time'
        this.sortOrder = 'descending'
      } else {
        this.sortColumn = prop
        this.sortOrder = order
      }
      this.getTableData({ page_num: 1 })
    },
    getLevelName(l) {
      const level =
        this.projectLevels.find((item) => item.project_code == l) || {}
      return level.project_type || this.$tt("未知级别");
    },
    refresh(notFirstPage) {
      this.switchDialogVisible(false)
      this.getTableData(notFirstPage ? {} : { page_num: 1 })
    },
    bindSecretKey(id) {
      this.activeSecretKeyId = id
      this.dialogVisible = true
    },
    editSecretTime(id) {
      this.editTimeId = id
      this.editVisible = true
    },
    deleteSecretKey(id) {
      this.$request.deleteSecretKeys({ ids: [id] }).then((res) => {
        if (res.status !== 'success') {
          this.$message.error(res.msg || this.$tt('删除失败'))
          return
        }
        this.$message.success(this.$tt('删除成功'))
        this.getTableData({})
      })
    },
    resetClick(id) {
      this.$request.updateSecretKeyStatus({ id }).then((res) => {
        if (res.status != 'success') {
          this.$message.error(res.msg)
          return
        }
        this.getTableData({})
      })
    },
    handleEdit() {},
    switchDialogVisible(bol, key) {
      this.activeDialogKey = key
      this.dialogVisible = bol
    },
    handleSizeChange(page_size) {
      this.getTableData({ page_size, page_num: 1 })
    },
    handleCurrentPageChange(page_num) {
      this.getTableData({ page_num })
    },
    getTableData({ page_num, page_size }) {
      if (page_num) {
        this.pageInfo.page_num = page_num
      }
      if (page_size) {
        this.pageInfo.page_size = page_size
      }
      const params = {
        ...this.pageInfo,
        use_scenes: this.form.use_scenes,
        sn: this.form.sn,
        phone: this.form.phone,
        test: this.form.test,
        time_type: this.form.time_type,
        sort_column: this.sortColumn,
        sort_order: this.sortOrder,
      }
      if (this.form.status !== '' && this.form.status !== null && this.form.status !== undefined) {
        params.status = this.form.status
      }
      if (this.form.time_range && this.form.time_range.length === 2) {
        const t0 = new Date(this.form.time_range[0]).getTime()
        const t1 = new Date(this.form.time_range[1]).getTime()
        if (!Number.isNaN(t0) && !Number.isNaN(t1)) {
          params.time_start = t0
          params.time_end = t1
        }
      }
      this.timelineLoading = true
      this.$request.querySecretKeysList(params).then((res) => {
        if (res.status != 'success') {
          this.$message.error(res.msg)
          return
        }
        this.tableDataInfo = res.data || {}
      }).finally(() => {
        this.timelineLoading = false
      })
    },
    timelineStamp(row) {
      const field = this.form.time_type === 'activation_time' ? 'activation_time' : 'create_time'
      const label = this.form.time_type === 'activation_time' ? this.$tt('激活') : this.$tt('创建')
      const t = this.dateTransform(row[field])
      return t ? `${label} ${t}` : label
    },
    dateTransform(d) {
      if (!d) return
      return moment(d).format('YYYY-MM-DD HH:mm')
    },
  },
}
</script>
<style lang="scss" scoped>
.search-form {
  padding-top: 16px;
}
.toolbar-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}
.toolbar-row .addManager {
  margin: 0;
}
.view-mode-toggle {
  margin-left: auto;
}
.keys-timeline-wrap {
  min-height: 120px;
  padding: 8px 4px 24px;
}
.timeline-card {
  max-width: 960px;
}
.timeline-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-weight: 600;
}
.timeline-key {
  font-family: Consolas, monospace;
  letter-spacing: 0.02em;
}
.timeline-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  font-size: 13px;
  color: #606266;
  margin-bottom: 6px;
}
.timeline-ops {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid #ebeef5;
}
</style>
<style lang="scss">
.keysWrap {
  padding: 0 24px 24px;
  background-color: #fff;
  .addManager {
    margin: 0px 0 16px;
  }
  .keysTable {
    .inactive {
      color: #909399c9;
    }
    .active {
      color: #67c23a;
    }
    .el-button {
      margin-left: 10px !important;
    }
  }
}
</style>
